var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKebab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 16.5C0.5 15.3954 1.39551 14.5 2.50008 14.5C3.60465 14.5 4.50016 15.3954 4.50016 16.5C4.50016 17.6046 3.60465 18.5 2.50008 18.5C1.39551 18.5 0.5 17.6046 0.5 16.5ZM0.5 9.5C0.5 8.39543 1.39551 7.5 2.50008 7.5C3.60465 7.5 4.50016 8.39543 4.50016 9.5C4.50016 10.6046 3.60465 11.5 2.50008 11.5C1.39551 11.5 0.5 10.6046 0.5 9.5ZM2.50008 0.5C1.39551 0.5 0.5 1.39543 0.5 2.5C0.5 3.60457 1.39551 4.5 2.50008 4.5C3.60465 4.5 4.50016 3.60457 4.50016 2.5C4.50016 1.39543 3.60465 0.5 2.50008 0.5Z",
    fill: "#C1C1C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebab);
export default __webpack_public_path__ + "static/media/kebab.2328cd420730470c65ec42091dd033d2.svg";
export { ForwardRef as ReactComponent };